import React from 'react'
import './add-author.styles.scss'
import Worker from './worker'
import FormHelper from '../../../../utils/FormHelper'
import Form from './form.component'
import Loading from '../../../../components/loading/loading.component'

class AddAuthor extends React.Component {

    constructor(props) {
        super(props)
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState()
    }

    onSubmit = e => {
        e.preventDefault()
        this.worker.isValid() && this.worker.addAuthor()
    }

    render() {
        return (
            <div className="add-author card">
                <div className="header">
                    <h4>{this.props.title}</h4>
                </div>
                <div className={"flag " + this.state.flag.type}>
                    {this.state.flag.text}
                </div>
                {this.state.creating? <Loading/>:<Form {...this.state} onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.props.onCancel}/>}
            </div>
        )
    }
}

export default AddAuthor